import ParentAccountReportSummaryContainer from './parent_account_report_summary_container';

const ParentAccountReportSummary = ParentAccountReportSummaryContainer;
export default ParentAccountReportSummary;
